module.exports = __webpack_public_path__ + "static/media/surtidor-verde.ca35bb5f.svg";